import client, { unwrap } from './client';

export const getChannels = () =>
  client.get('/profit-pulse/channels').then(unwrap);

export const updateChannel = (channelId, body) =>
  client.patch(`/profit-pulse/channels/${channelId}`, body).then(unwrap);
